/* ==========================================================================
   LOS SUEÑOS DE… — TEMPORADA 2 · JS de la landing (Shopify)
   - Validación cliente (progressive enhancement) sobre {% form 'contact' %}
   - Carrusel + modal YouTube lazy (iframe solo al click)
   - Tracking dataLayer (GA4/GTM)
   ========================================================================== */
(function () {
  "use strict";
  if (window.__lsInit) return;      // guard anti doble-carga
  window.__lsInit = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  ready(function () {

    var LS_LOADED = Date.now(); // para el candado de "tiempo mínimo"

    /* ---- Scroll suave para anclas internas (CTA hero → #registro) ---- */
    $all('.ls a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        if (a.hasAttribute("data-track")) track(a.getAttribute("data-track"));
        var href = a.getAttribute("href");
        if (href && href.length > 1) {
          var target = document.getElementById(href.slice(1));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: "smooth", block: "start" });
            if (history.replaceState) history.replaceState(null, "", href);
          }
        }
      });
    });

    /* ---- Reveal + pulse único al entrar al viewport ---- */
    var revealEls = $all(".ls-step, .ls-card, .ls-ep, .ls-sec-head");
    revealEls.forEach(function (el) { el.setAttribute("data-reveal", ""); });
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
        });
      }, { threshold: 0.18 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add("is-in"); });
    }

    /* ---- Contador del textarea "¿Por qué tú?" ---- */
    var why = $('[data-field="whyYou"]');
    if (why) {
      var whyMax = parseInt(why.getAttribute("maxlength"), 10) || 500;
      var whyCount = $("#f-why-count");
      var counterWrap = why.closest(".ls-field") ? $(".ls-counter", why.closest(".ls-field")) : null;
      why.addEventListener("input", function () {
        if (whyCount) whyCount.textContent = String(why.value.length);
        if (counterWrap) counterWrap.classList.toggle("is-max", why.value.length >= whyMax);
      });
    }

    /* ==================================================================
       FORMULARIO
       ================================================================== */
    var form = $("#ls-form");
    var cfg = (form && form.closest(".ls-reg")) || form;
    if (form) form.setAttribute("novalidate", "novalidate");

    var VALIDATORS = {
      fullName: function (v) { return v.trim().length >= 3 || "Escribe tu nombre completo."; },
      age: function (v) { var n = parseInt(v, 10); return (v !== "" && n >= 1 && n <= 120) || "Ingresa una edad válida."; },
      email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Ingresa un correo válido."; },
      phone: function (v) { return (v.replace(/\D/g, "").length >= 10) || "Ingresa un teléfono a 10 dígitos."; },
      cityState: function (v) { return v.trim().length >= 2 || "Escribe tu ciudad o estado."; },
      videoUrl: function (v) { return /^https:\/\/.+/i.test(v.trim()) || "Pega un enlace válido (https://…)."; }
    };

    function fieldByKey(key) { return form ? form.querySelector('[data-field="' + key + '"]') : null; }
    function wrapOf(input) { return input.closest(".ls-field") || input.closest(".ls-card"); }

    function setError(input, msg) {
      var wrap = wrapOf(input);
      if (wrap) { wrap.classList.add("is-invalid"); wrap.classList.remove("is-valid"); }
      var desc = input.getAttribute("aria-describedby");
      if (desc) {
        var ids = desc.split(/\s+/);
        var errEl = document.getElementById(ids[ids.length - 1]);
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      }
      input.setAttribute("aria-invalid", "true");
    }
    function clearError(input) {
      var wrap = wrapOf(input);
      if (wrap) { wrap.classList.remove("is-invalid"); wrap.classList.add("is-valid"); }
      var desc = input.getAttribute("aria-describedby");
      if (desc) {
        var ids = desc.split(/\s+/);
        var errEl = document.getElementById(ids[ids.length - 1]);
        if (errEl) { errEl.hidden = true; errEl.textContent = ""; }
      }
      input.removeAttribute("aria-invalid");
    }
    function validateField(input) {
      var key = input.getAttribute("data-field");
      if (!key || !VALIDATORS[key]) return true;
      var res = VALIDATORS[key](input.value);
      if (res === true) { clearError(input); return true; }
      setError(input, res);
      return false;
    }

    var formStarted = false;
    if (form) {
      $all("[data-field]", form).forEach(function (input) {
        if (input.type === "checkbox" || input.type === "radio") return;
        input.addEventListener("blur", function () { if (formStarted) validateField(input); });
        input.addEventListener("focus", function () {
          if (!formStarted) { formStarted = true; track("los_suenos_form_start"); }
        });
      });

      form.addEventListener("submit", function (e) {
        // ---- Candados anti-spam ----
        var hp = form.querySelector('[name="ls_hp"]');
        if (hp && hp.value.trim() !== "") { e.preventDefault(); return; } // honeypot: bot
        if (Date.now() - LS_LOADED < 2500) { // llenado sospechosamente rápido
          e.preventDefault();
          track("los_suenos_form_error", { reason: "too_fast" });
          var ce = $("#e-consents");
          if (ce) { ce.textContent = "Espera un momento y vuelve a intentar."; ce.hidden = false; }
          return;
        }

        formStarted = true;
        var firstInvalid = null;

        Object.keys(VALIDATORS).forEach(function (key) {
          var input = fieldByKey(key);
          if (!input) return;
          if (!validateField(input) && !firstInvalid) firstInvalid = input;
        });

        // Plataforma (radio)
        var platformChecked = !!(form.querySelector('[data-field="platform"]:checked'));
        var platformErr = $("#e-platform");
        if (!platformChecked) {
          if (platformErr) { platformErr.textContent = "Selecciona la plataforma."; platformErr.hidden = false; }
          if (!firstInvalid) firstInvalid = form.querySelector('[data-field="platform"]');
        } else if (platformErr) { platformErr.hidden = true; }

        // Consentimientos (checkboxes)
        var CONSENTS = ["acceptTerms", "acceptPrivacy", "authorizeImage"];
        var consentsOk = CONSENTS.every(function (k) { var el = fieldByKey(k); return el && el.checked; });
        var consentErr = $("#e-consents");
        if (!consentsOk) {
          if (consentErr) { consentErr.textContent = "Debes aceptar todas las casillas para participar."; consentErr.hidden = false; }
          if (!firstInvalid) {
            for (var ci = 0; ci < CONSENTS.length; ci++) {
              var cel = fieldByKey(CONSENTS[ci]);
              if (cel && !cel.checked) { firstInvalid = cel; break; }
            }
          }
        } else if (consentErr) { consentErr.hidden = true; }

        if (firstInvalid) {
          e.preventDefault();
          track("los_suenos_form_error");
          if (firstInvalid.focus) firstInvalid.focus();
          if (firstInvalid.scrollIntoView) firstInvalid.scrollIntoView({ block: "center", behavior: "smooth" });
          return;
        }

        var endpoint = (cfg && cfg.getAttribute("data-endpoint")) || "";
        var btn = $(".ls-form__submit", form);
        track("los_suenos_form_submit");

        if (endpoint) {
          // Enviar SOLO a la Google Sheet y mostrar el éxito por JS.
          // Se evita el contact form nativo (y su reCAPTCHA), que interrumpía el envío.
          e.preventDefault();
          if (btn) { btn.classList.add("is-loading"); btn.disabled = true; }
          try {
            var payloadStr = JSON.stringify(collectPayload());
            if (navigator.sendBeacon) {
              navigator.sendBeacon(endpoint, new Blob([payloadStr], { type: "text/plain;charset=utf-8" }));
            } else {
              fetch(endpoint, { method: "POST", mode: "no-cors", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: payloadStr });
            }
          } catch (err) {}
          track("los_suenos_form_success");
          showSuccessJS();
          return;
        }

        // Sin endpoint configurado: se usa el contact form nativo (email) + recarga.
        if (btn) { btn.classList.add("is-loading"); btn.disabled = true; }
      });

      function showSuccessJS() {
        var sbtn = $(".ls-form__submit", form);
        if (sbtn) { sbtn.classList.remove("is-loading"); sbtn.disabled = false; } // detener spinner
        var ok = $("#ls-success");
        if (ok) { ok.hidden = false; ok.classList.add("is-modal"); }
        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", onSuccessKey);
      }

      function closeSuccess() {
        var ok = $("#ls-success");
        if (ok) { ok.classList.remove("is-modal"); ok.hidden = true; }
        document.body.style.overflow = "";
        document.removeEventListener("keydown", onSuccessKey);
        try {
          form.reset();
          $all(".is-valid, .is-invalid", form).forEach(function (el) { el.classList.remove("is-valid", "is-invalid"); });
        } catch (e) {}
      }

      function onSuccessKey(e) { if (e.key === "Escape") closeSuccess(); }

      // Cerrar el popup: botón X, click en el fondo, o "Ver episodios"
      var successBox = $("#ls-success");
      if (successBox) {
        successBox.addEventListener("click", function (e) {
          if (e.target === successBox || (e.target.closest && e.target.closest("[data-ls-close], .ls-success__cta"))) {
            closeSuccess();
          }
        });
      }
    }

    function collectPayload() {
      function v(k) { var el = fieldByKey(k); return el ? el.value.trim() : ""; }
      function c(k) { var el = fieldByKey(k); return el ? !!el.checked : false; }
      var platformEl = form.querySelector('[data-field="platform"]:checked');
      return {
        fullName: v("fullName"), age: v("age"), email: v("email"), phone: v("phone"),
        cityState: v("cityState"),
        videoUrl: v("videoUrl"), platform: platformEl ? platformEl.value : "",
        acceptTerms: c("acceptTerms"), acceptPrivacy: c("acceptPrivacy"), authorizeImage: c("authorizeImage"),
        campaign: (cfg && cfg.getAttribute("data-campaign")) || "los-suenos-temporada-2",
        source: (window.location && window.location.pathname) || "",
        token: (cfg && cfg.getAttribute("data-token")) || ""
      };
    }

    // Estado de éxito servido por Liquid (contact form nativo + recarga)
    var successEl = $("#ls-success");
    if (successEl && !successEl.hidden) {
      track("los_suenos_form_submit");
      track("los_suenos_form_success");
      var regSec = successEl.closest(".ls-reg");
      if (regSec) {
        regSec.classList.add("ls-reg--done");
        var head = regSec.querySelector(".ls-sec-head");
        if (head) head.style.display = "none";
      }
      successEl.scrollIntoView({ block: "center", behavior: "smooth" });
    }

    /* ==================================================================
       EPISODIOS — modal YouTube (iframe solo al click)
       ================================================================== */
    $all(".ls-ep__btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-video-id") || "";
        var title = btn.getAttribute("data-title") || "";
        var num = btn.getAttribute("data-episode") || "";
        track("los_suenos_episode_click", { episode: num });
        openModal(id, title);
      });
    });

    var modal = $("#ls-modal");
    var modalFrame = $("#ls-modal-frame");
    var lastFocused = null;

    function openModal(id, title) {
      if (!modal || !modalFrame) return;
      lastFocused = document.activeElement;
      modalFrame.innerHTML = "";
      if (id) {
        var iframe = document.createElement("iframe");
        iframe.src = "https://www.youtube-nocookie.com/embed/" + id + "?autoplay=1&rel=0";
        iframe.title = title || "Video";
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.setAttribute("allowfullscreen", "");
        modalFrame.appendChild(iframe);
        track("los_suenos_youtube_modal_open", { id: id });
      } else {
        var msg = document.createElement("div");
        msg.className = "ls-modal__msg";
        msg.textContent = "Agrega la URL de YouTube de este episodio en el editor de Shopify para reproducirlo aquí.";
        modalFrame.appendChild(msg);
      }
      modal.hidden = false;
      document.body.style.overflow = "hidden";
      var closeBtn = $(".ls-modal__close", modal);
      if (closeBtn) closeBtn.focus();
      document.addEventListener("keydown", onKeydown);
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      if (modalFrame) modalFrame.innerHTML = "";
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }
    function onKeydown(e) {
      if (e.key === "Escape") { closeModal(); return; }
      if (e.key === "Tab") {
        var focusables = $all("button, a[href], iframe", modal);
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (modal) $all("[data-close]", modal).forEach(function (el) { el.addEventListener("click", closeModal); });
  });
})();
